import { IMPORT_QUESTIONNAIRE } from "../types";

export default function(obj) {
  return {
    ...obj,
    graph: obj.payload.graph,
    type: IMPORT_QUESTIONNAIRE
  };
}
